import { useEffect, useState } from "react";
import { Mail, Send, MessageCircle, Eye } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import api from "@/lib/api";

export default function WelcomePreviewDialog({ contestId, unsaved }) {
  const [open, setOpen] = useState(false);
  const [preview, setPreview] = useState(null);
  const [sending, setSending] = useState(false);
  useEffect(() => { if (open) { setPreview(null); api.welcomePreview(contestId).then(setPreview).catch(() => toast.error("Anteprima non disponibile")); } }, [open, contestId]);
  const sendTest = async () => {
    setSending(true);
    try { const r = await api.welcomePreviewSend(contestId); toast.success(`Email di prova inviata a ${r.sent_to}`); } catch (e) { toast.error(e?.response?.data?.detail || "Invio non riuscito"); } finally { setSending(false); }
  };
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild><Button variant="outline" size="sm" className="gap-2 border-border" data-testid="welcome-preview-open"><Eye className="h-4 w-4" /> Anteprima benvenuto</Button></DialogTrigger>
      <DialogContent className="max-w-3xl" data-testid="welcome-preview-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Mail className="h-5 w-5" /> Email di benvenuto del concorso</DialogTitle>
          <DialogDescription>Anteprima con dati di esempio (Mario Rossi) e le impostazioni salvate del premio iscrizione.{unsaved ? " Hai modifiche non salvate: salva per vederle qui." : ""}</DialogDescription>
        </DialogHeader>
        <div className="space-y-3 min-w-0">
          <div className="flex items-center justify-between gap-2 flex-wrap">
            <p className="text-sm"><span className="text-muted-foreground">Oggetto:</span> <b data-testid="welcome-preview-subject">{preview?.subject || "…"}</b></p>
            <Button size="sm" onClick={sendTest} disabled={!preview || sending} className="gap-2" data-testid="welcome-preview-send"><Send className="h-4 w-4" /> {sending ? "Invio…" : "Inviami una prova"}</Button>
          </div>
          <div className="rounded-xl border border-border overflow-hidden bg-white">
            {preview ? <iframe title="anteprima" srcDoc={preview.html} className="w-full h-[420px]" data-testid="welcome-preview-frame" /> : <div className="h-[420px] grid place-items-center text-sm text-muted-foreground">Caricamento…</div>}
          </div>
          {preview?.whatsapp && (
            <div className="rounded-xl border border-emerald-500/30 bg-emerald-500/5 p-3" data-testid="welcome-preview-whatsapp">
              <p className="text-xs font-semibold flex items-center gap-1.5 mb-1"><MessageCircle className="h-3.5 w-3.5 text-emerald-600" /> Versione WhatsApp (se attiva)</p>
              <p className="text-sm whitespace-pre-line">{preview.whatsapp}</p>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
